import uniqBy from 'lodash.uniqby';
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';

export default {
  token(state) {
    return get(state, 'credentials.token', '');
  },
  email: (state) => get(state, 'credentials.email', ''),
  name: (state) => get(state, 'credentials.name', ''),
  products: (state) => state.products.sort((x, y) => {
    return y.created - x.created
  }),
  sharedProducts: (state) => state.sharedProducts,
  likesByProductIdShared: (state) => {
    const likesByProductIdShared = {};
    state.sharedProducts.forEach((product) => {
      if (!isEmpty(get(product, 'data.likes'))) {
        const likes = Object.values(product.data.likes).filter((like) => like.type === 'fire');
        likesByProductIdShared[product.productId] = likes;
      }
    });
    return likesByProductIdShared;
  },
  mehByProductIdShared: (state) => {
    const mehByProductIdShared = {};
    state.sharedProducts.forEach((product) => {
      if (!isEmpty(get(product, 'data.likes'))) {
        const likes = Object.values(product.data.likes).filter((like) => like.type === 'meh');
        mehByProductIdShared[product.productId] = likes;
      }
    });
    return mehByProductIdShared;
  },
  likesByProductId: (state) => {
    const likesByProductId = {};
    state.products.forEach((product) => {
      if (product.data) {
        const likes = Object.values(product.data.likes).filter((like) => like.type === 'fire');
        likesByProductId[product.productId] = likes;
      }
    });
    return likesByProductId;
  },
  mehByProductId: (state) => {
    const mehByProductId = {};
    state.products.forEach((product) => {
      if (product.data) {
        const likes = Object.values(product.data.likes).filter((like) => like.type === 'meh');
        mehByProductId[product.productId] = likes;
      }
    });
    return mehByProductId;
  },
  sharedMerchantUrls: (state) => uniqBy(state.sharedProducts, (product) => product.merchantUrl).map((product) => product.merchantUrl),
  sharedEmails: (state) => uniqBy(state.sharedProducts, (product) => product.email).map((product) => product.email),
  isLoading: (state) => state.isLoading,
  categories: (state) => state.categories,
  banners: (state) => state.banners,
  merchantUrls: (state) => uniqBy(state.products, (product) => product.merchantUrl).map((product) => product.merchantUrl),
  alarmProducts: (state) => state.alarmProducts,
  isIframe: (state) => state.isIframe
};
